import { currentBrand as brandName } from 'config';

// The following URLs needs to be whitelisted within IDK (including domain and port)

const brandPathPrefix = process.env.NODE_ENV === 'production' ? `/${brandName}` : '';

export function withBrandPrefix(path: string): string {
    return `${brandPathPrefix}${path}`;
}

export function loginPath(): string {
    return withBrandPrefix('/login');
}
export function notFoundPagePath(): string {
    return withBrandPrefix('/not-found');
}

export function registrationPagePath(): string {
    return withBrandPrefix('/register');
}

export function invitationPagePath(): string {
    return withBrandPrefix('/invitation');
}

export function notAuthorizedPagePath(): string {
    return withBrandPrefix('/not-authorized');
}

export function dashboardPagePath(): string {
    return withBrandPrefix('/dashboard');
}

export function digitalRenewalPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/digital-renewal/${contractId}`);
}

export function digitalRenewalRefinanceOrPaymentPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/refinance-or-payment/${contractId}`);
}

export function digitalRenewalReturnOfTheCarPath(contractId = ':contractId'): string {
    return withBrandPrefix(`/return-of-the-car/${contractId}`);
}
export function digitalRenewalJointContractPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/joint-contract/${contractId}`);
}

export function faqPagePath(): string {
    return withBrandPrefix('/faq');
}

export function cookiePolicyPath(): string {
    return withBrandPrefix('/cookie-policy');
}

export function legalNoticePath(): string {
    return withBrandPrefix('/legal-notice');
}

export function privacyPolicyPath(): string {
    return withBrandPrefix('/privacy-policy');
}

export function landingPagePath(): string {
    return withBrandPrefix('/');
}

export function logoutPath(): string {
    return withBrandPrefix('/logout');
}

export function totalEarlySettlementPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/total-early-settlement/${contractId}`);
}

export function earlySettlementLeasingPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/early-settlement-leasing/${contractId}`);
}

export function totalEarlySettlementContractSelectorPagePath(): string {
    return withBrandPrefix('/total-early-settlement');
}

export function myProfilePagePath(): string {
    return withBrandPrefix('/my-profile');
}

export function changeContactDetailsPath(): string {
    return `${myProfilePagePath()}/change-contact-details`;
}

export function changeInvoiceConsentPath(): string {
    return `${myProfilePagePath()}/change-invoice-consent`;
}

export function changeAddressDetailsPath(): string {
    return `${myProfilePagePath()}/change-address-details`;
}

export function changeMonthlyDueDatePath(contractId = ':contractId'): string {
    return `${dashboardPagePath()}/${contractId}/change-monthly-due-date`;
}

export function changeIbanPath(contractId = ':contractId'): string {
    return `${dashboardPagePath()}/${contractId}/change-iban`;
}

export function requestCertificatePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/request-certificate/${contractId}`);
}

export function unpaidDetailsPath(contractId = ':contractId'): string {
    return withBrandPrefix(`/unpaid-details/${contractId}`);
}

export function paymentSuccessPath(): string {
    return withBrandPrefix('/payment-succeeded');
}

export function paymentErrorPath(): string {
    return withBrandPrefix('/payment-failed');
}

export function postboxPagePath(contractId?: string): string {
    return contractId ? withBrandPrefix(`/postbox/${contractId}`) : withBrandPrefix('/postbox');
}

export function amortizationTablePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/amortization-table/${contractId}`);
}

export function totalEarlySettlementFutureQuotePath(contractId = ':contractId'): string {
    return `${totalEarlySettlementContractSelectorPagePath()}/${contractId}/future-quote`;
}

export function partialEarlySettlementPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/partial-early-settlement/${contractId}`);
}

export function earlySettlementPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/early-settlement/${contractId}`);
}

export function myRequestPagePath(): string {
    return withBrandPrefix('/my-request');
}

export function identityBrokerErrorPagePath(): string {
    return withBrandPrefix('/error');
}

export function featureAppLicensesPagePath(): string {
    return withBrandPrefix('/feature-app-licenses');
}

export function requestSubragationPagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/request-subrogation/${contractId}`);
}

export function requestVehicleReturnPagePath(): string {
    return withBrandPrefix('/vehicle-return/');
}

export function privatePersonSubragationPagePath(contractId = ':contractId'): string {
    return `${requestSubragationPagePath(contractId)}/private-person`;
}

export function legalPersonSubragationPagePath(contractId = ':contractId'): string {
    return `${requestSubragationPagePath(contractId)}/legal-person`;
}

export function corporateNameChangingSubragationPagePath(contractId = ':contractId'): string {
    return `${requestSubragationPagePath(contractId)}/corporate-name-changing`;
}

export function requestVehiclePurchasePagePath(contractId = ':contractId'): string {
    return withBrandPrefix(`/request-vehicle-purchase/${contractId}`);
}

export function contractRecalculation(contractId = ':contractId', vinCode = ':vinCode'): string {
    return withBrandPrefix(`/contract-recalculation/${contractId}/${vinCode}`);
}

export function loginRedirectPagePath(): string {
    return withBrandPrefix('/login-redirect');
}
